<div class="container h-100">
  <div *ngIf="isLoading" class="row h-100 justify-content-center align-items-center">
    <div class="text-center">
      <app-loading-spinner></app-loading-spinner>
    </div>
  </div>
  <div class="row justify-content-center align-items-center VerticalMargin mb-5" *ngIf="!isLoading">
    <div class="card RegularForm rounded col-12 col-sm-9 col-lg-6" >
      <div class="card-body MyCardBody rounded-bottom">
        <div class="alert alert-primary text-center" role="alert" *ngIf="leaders.length > 0">
          {{ globalService.Get("GROUP_LEADERS") }}
        </div>
        <div *ngFor="let member of leaders">
          <form #memberForm="ngForm" [class.SmallArabicFont]="globalService.isRTL == true">
            <input type="hidden" class="form-control" name="id" required #id="ngModel" [(ngModel)]="member.id" />
            <div class="row m-2">
              <div class="input-group col-12">
                <input type="text" name="fullName" class="form-control" [readonly]="true"
                  [value]="member.firstName + ' ' + member.lastName" />
                <button class="btn optionButton " [class.ml-1]="globalService.isRTL == false"
                  [class.mr-1]="globalService.isRTL == true"
                  [class.btn-outline-secondary]="(!member['expandFunctions']) || (member['expandFunctions'] == false)"
                  [class.btn-primary]="member['expandFunctions'] == true" (click)="ExpandFunctions(member)"
                  type="button">
                  <i class="fas"
                    [class.fa-angle-up]="(!member['expandFunctions']) || (member['expandFunctions'] == false)"
                    [class.fa-angle-down]="member['expandFunctions'] == true"></i>
                </button>
              </div>
            </div>
            <div *ngIf="member['expandFunctions']==true" class="mx-4">
              <app-user-tools [user]="currentUser" [subdomain]="subdomain" *ngIf="user.expandFunctions"></app-user-tools>
            </div>
          </form>
        </div>
        <div *ngIf="leaders.length > 0">
          <br>
        </div>
        <div class="alert alert-primary text-center" role="alert" *ngIf="members.length > 0">
          {{ globalService.Get("GROUP_MEMBERS") }}
        </div>
        <div *ngFor="let member of members">
          <form #memberForm="ngForm" [class.SmallArabicFont]="globalService.isRTL == true">
            <input type="hidden" class="form-control" name="id" required #id="ngModel" [(ngModel)]="member.id" />
            <div class="row m-2">
              <div class="input-group col-12">
                <input type="text" name="fullName" class="form-control" [readonly]="true"
                  [value]="member.firstName + ' ' + member.lastName" />
                <button class="btn optionButton " [class.ml-1]="globalService.isRTL == false"
                  [class.mr-1]="globalService.isRTL == true"
                  [class.btn-outline-secondary]="(!member['expandFunctions']) || (member['expandFunctions'] == false)"
                  [class.btn-primary]="member['expandFunctions'] == true" (click)="ExpandFunctions(member)"
                  type="button">
                  <i class="fas"
                    [class.fa-angle-up]="(!member['expandFunctions']) || (member['expandFunctions'] == false)"
                    [class.fa-angle-down]="member['expandFunctions'] == true"></i>
                </button>
              </div>
            </div>
            <div *ngIf="member['expandFunctions']==true" class="mx-4">
              <app-user-tools [user]="currentUser" [subdomain]="subdomain" *ngIf="user.expandFunctions"></app-user-tools>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>